import { ComponentProps, PropsWithChildren } from "react";
import { StyleSheet } from "react-native";

import BMTray from "./BMTray";

type Props = ComponentProps<typeof BMTray> & {
  fullscreen?: boolean;
};

export default function Tray(props: PropsWithChildren<Props>) {
  const { fullscreen, ...rest } = props;
  return (
    <BMTray
      {...rest}
      containerStyle={fullscreen ? styles.fullscreen : undefined}
    />
  );
}

const styles = StyleSheet.create({
  fullscreen: {
    paddingHorizontal: 0,
    bottom: -12,
  },
});
